import { HStack, Image, Text, Tooltip } from '@chakra-ui/react';
import type { LucideIcon } from 'lucide-react';

type Props = ({ icon: LucideIcon; iconSrc?: never } | { icon?: never; iconSrc: string }) & {
  label: string;
  active?: boolean;
  activeColor?: string;
  onClick: () => void;
  filled?: boolean;
  count?: number;
};

// A circular reaction control. Widens to a pill when it carries a count.
const ReactionButton = ({
  icon: Icon,
  iconSrc,
  label,
  active,
  activeColor = 'primary.500',
  onClick,
  filled,
  count,
}: Props) => (
  <Tooltip label={label} placement="top" hasArrow>
    <HStack
      as="button"
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-pressed={active}
      justify="center"
      gap="6px"
      minWidth="48px"
      height="48px"
      paddingX={count ? '14px' : '0'}
      width={count ? 'auto' : '48px'}
      borderRadius="full"
      backgroundColor="white"
      color={active ? activeColor : 'text.mediumBlue'}
      borderWidth="2px"
      borderColor={iconSrc && active ? activeColor : 'transparent'}
      boxShadow="0px 4px 14px rgba(14, 0, 98, 0.10)"
      transition="all 0.15s ease"
      _hover={{ transform: 'translateY(-2px)', color: activeColor, borderColor: iconSrc ? activeColor : 'transparent' }}
      _active={{ transform: 'scale(0.94)' }}
    >
      {iconSrc ? (
        <Image src={iconSrc} alt="" width="20px" height="20px" objectFit="contain" />
      ) : Icon ? (
        <Icon size={20} strokeWidth={2} fill={active && filled ? 'currentColor' : 'none'} />
      ) : null}
      {Boolean(count) && (
        <Text fontSize="14px" fontWeight={600}>
          {count}
        </Text>
      )}
    </HStack>
  </Tooltip>
);

export default ReactionButton;
